import { css } from '@emotion/react';

import { useZackeyAgentPDPEntryContext } from '../provider/ZackeyAgentPDPEntryProvider';

const ZACKEY_BUTTON_IMAGE_URL =
  'https://cf.image-farm.s.zigzag.kr/original/cms/2026/01/20/202601200511525042_054160.png';
const ZACKEY_BUTTON_SIZE = 50;

export interface ZackeyPdpEntryButtonProps {
  /** 현재 PDP의 카탈로그 상품 ID */
  catalogProductId: string;
  /** 기존 세션 ID (재진입 시 사용) */
  sessionId?: string;
}

/**
 * 재키 PDP 엔트리 이미지 버튼
 *
 * - 50x50 이미지 버튼 UI
 * - 접근성: aria-label 제공
 * - 클릭 시 컨텍스트의 openZackeyAgent 호출
 */
export const ZackeyPdpEntryButton = (props: ZackeyPdpEntryButtonProps) => {
  const { catalogProductId, sessionId } = props;
  const { openZackeyAgent } = useZackeyAgentPDPEntryContext();

  const handleClick = () => {
    openZackeyAgent({ catalogProductId, sessionId });
  };

  return (
    <button css={buttonCss} type='button' aria-label='재키 쇼핑 도우미 열기' onClick={handleClick}>
      <img
        css={imageCss}
        src={ZACKEY_BUTTON_IMAGE_URL}
        alt=''
        width={ZACKEY_BUTTON_SIZE}
        height={ZACKEY_BUTTON_SIZE}
        loading='lazy'
      />
    </button>
  );
};

const buttonCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${ZACKEY_BUTTON_SIZE}px;
  height: ${ZACKEY_BUTTON_SIZE}px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const imageCss = css`
  display: block;
  width: ${ZACKEY_BUTTON_SIZE}px;
  height: ${ZACKEY_BUTTON_SIZE}px;
  border-radius: 50%;
  object-fit: cover;
`;
